import { useEffect, useState } from 'react'

/** Live input level, newest bar on the right. It listens itself, so only the meter re-renders at the mic's rate. */
export function LevelMeter({
  subscribe,
  bars = 28,
  height = 28,
  className = '',
}: {
  /** Level updates (0..1); returns an unsubscribe. */
  subscribe(fn: (level: number) => void): () => void
  bars?: number
  height?: number
  className?: string
}) {
  const [levels, setLevels] = useState<number[]>([])
  useEffect(() => subscribe((l) => setLevels((prev) => (prev.length >= bars ? [...prev.slice(1), l] : [...prev, l]))), [subscribe, bars])
  const pad = bars - levels.length
  return (
    <div aria-hidden className={`flex items-center gap-[2px] ${className}`} style={{ height }}>
      {Array.from({ length: bars }, (_, i) => {
        const l = i < pad ? 0 : levels[i - pad]
        return (
          <span
            key={i}
            style={{ height: Math.max(3, Math.round(l * height)) }}
            className={`w-[3px] shrink-0 rounded-full transition-[height] duration-75 ${i < pad ? 'bg-foreground/12' : 'bg-primary/80'}`}
          />
        )
      })}
    </div>
  )
}
